/**
 * cardButtonText.tsx
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled uppercase label used inside the card button pill.
 */
const CardButtonText = styled.span`
  color: #ffffff;
  flex: 1;
  font-family: ${Fonts['bold']};
  font-size: ${20 * Screen.widthRatio}px;
  padding-left: ${15 * Screen.widthRatio}px;
  line-height: ${29 * Screen.widthRatio}px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;

export default CardButtonText;
